import axios from "axios";
import { Template } from "../../components/Templates/TemplateList";
import config  from '../../env.json';

export function getBaseTemplates(): Promise<Template[]> {
  return new Promise((resolve, reject) => {
    axios
      .get(config.REACT_APP_ENV_API_BASE + "/templates/getTemplates")
      .then((res) => {
        // The response is likely already parsed as JSON by axios
        const data = res.data;
        console.log('API response:', data);

        let mappedData: Template[] = [];
        
        if (Array.isArray(data)) {
          mappedData = data.map((config) => {
            const templates = config.Templates || [];

            return {
              id: templates.map((t: any) => t.Id?.toString()).join(", "),
              template: templates.map((t: any) => t.Config_Nm).join(", "),
              config_cd: config.Config_Cd || "",
              config_url: templates.map((t: any) => t.Config_Url).join(", "),
              config_desc: templates.map((t: any) => t.Config_Desc).join(", "),
              zone: config.ConfigAzure_Zn || "",
              services: templates.map((t: any) => t.ConfigService_Typ),
            };
          });
        } else {
          // If the data is not an array, check if it needs to be parsed
          try {
            const parsedData = typeof data === 'string' ? JSON.parse(data) : data;
            if (Array.isArray(parsedData)) {
              mappedData = parsedData.map((config) => {
                const templates = config.Templates || [];
  
                return {
                  id: templates.map((t: any) => t.Id?.toString()).join(", "),
                  template: templates.map((t: any) => t.Config_Nm).join(", "),
                  config_cd: config.Config_Cd || "",
                  config_url: templates.map((t: any) => t.Config_Url).join(", "),
                  config_desc: templates.map((t: any) => t.Config_Desc).join(", "),
                  zone: config.ConfigAzure_Zn || "",
                  services: templates.map((t: any) => t.ConfigService_Typ),
                };
              });
            } else {
              console.warn("API response format is not as expected:", parsedData);
            }
          } catch (parseError) {
            console.error("Error parsing API response:", parseError);
            reject(parseError);
            return;
          }
        }

        resolve(mappedData);
      })
      .catch((error) => {
        console.error("API request failed:", error);
        reject(error);
      });
  });
}

export async function templateViewApi(id: string, callback: any) {
  try {
    await axios({
      method: "get",
      url: config.REACT_APP_ENV_API_BASE + `/templates/view/${id}`,
    })
      .then((res) => {
        if (res.data) callback(res.data);
      })
      .catch(() => {
        callback(null);
      });
  } catch (error) {
    callback(null);
  }
}
export async function createTemplate(payload: FormData, callback: any) {
  try {
    await axios({
      method: "POST",
      url: config.REACT_APP_ENV_API_BASE + "/templates",
      data: payload
    })
      .then((res) => {
        if (res.data) callback(res.data);
      })
      .catch(() => {
        callback(null);
      });
  } catch (error) {
    callback(null);
  }
}

// API service to fetch template details
export const fetchTemplateDetails = async (serviceId: number): Promise<any> => {
  try {
    const response = await fetch(`${config.REACT_APP_ENV_API_BASE}/templates/view/${serviceId}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch service ID: ${serviceId}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Error fetching service ID ${serviceId}:`, error);
    throw error;
  }
};

export const saveTemplateChanges = async (
  templateId: string, 
  body: Record<string, any>
): Promise<{ success: boolean; message: string; tenantId?: string; updatedServices?: string[] }> => {
  try {
    const response = await fetch(`${config.REACT_APP_ENV_API_BASE}/templates/${templateId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        // Add any auth headers if needed
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `API returned ${response.status}`);
    }

    const data = await response.json();
    return {
      success: true,
      message: data.message || "Changes saved successfully",
      tenantId: data.tenantId,
      updatedServices: data.updatedServices
    };
  } catch (error: any) {
    console.error("Error saving template changes:", error);
    return {
      success: false,
      message: error.message || "Failed to save changes"
    };
  }
};